<div class="callout secondary" [class.loading]="loading">
  <div class="grid-x grid-padding-x">
    <div class="cell small-12 medium-10 large-8">
      <button class="close" [tabindex]="isHidden? '-1' : '0'" role="button" [attr.aria-label]="'arialabel.close' | translate" (click)="closeForm()" [title]="textkeyPrefix + '.strompreis.close' | translate"><i class="icon-x"></i></button>
      <p [innerHTML]="textkeyPrefix + '.strompreis.text.electricity.price' | translate"></p>
      <div role="alert" class="form-errors" *ngIf="formError" [innerHTML]="textkeyPrefix + '.strompreis.error.' + formError | translate"></div>
      @if (!isHidden) {
        <form [formGroup]="form">
          <ng-container *ngFor="let field of formConfig.getFields()">
            <div formfield [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="false" [form]="form" [formModel]="field" [formConfig]="formConfig" [step]="textkeyPrefix + '.strompreis'" class="formfield {{field.type}} {{field.classes}}" *ngIf="field.isActive()"></div>
          </ng-container>

          <div class="grid-x grid-padding-x buttons">
            <div class="cell small-12 medium-6">
              <button (click)="saveForm()" [tabindex]="isHidden? '-1' : '0'" class="button primary" [innerHTML]="textkeyPrefix + '.strompreis.button.cost.save' | translate"></button>
            </div>
            @if (anfrage.userInput.grundpreis_euro_monat || anfrage.userInput.arbeitspreis_cent_kwh) {
              <div class="cell small-12 medium-6">
                <button [tabindex]="isHidden? '-1' : '0'" (click)="resetData()" class="button hollow primary" [innerHTML]="textkeyPrefix + '.strompreis.button.cost.reset' | translate"></button>
              </div>
            }
          </div>
        </form>
      }
    </div>
  </div>
</div>
